import { Box } from '@primer/react';
import { Heading } from '@upright/ui/common/generic/components/primer-custom/heading';
import { Text } from '@upright/ui/common/generic/components/primer-custom/text';

interface Props {
  negativeExplanation?: string;
  negativeExample?: string;
  positiveExplanation?: string;
  positiveExample?: string;
}

export const ImpactCategoryExamples = (props: Props) => {
  const { negativeExplanation, negativeExample, positiveExplanation, positiveExample } = props;

  return (
    <Box my={3}>
      <Heading fontSize="micro" sx={{ mb: 2 }}>
        Examples of positive and negative impacts
      </Heading>
      <Text>
        <Text as="span" fontWeight="semibold">
          Negative impacts:
        </Text>
        <ul style={{ marginTop: 4 }}>
          {negativeExplanation ? (
            <>
              <li>{negativeExplanation}</li>
              {negativeExample && <li>Simplified example: {formatImpactCategoryExample(negativeExample)}</li>}
            </>
          ) : (
            <li>No negative impacts are considered for this impact category.</li>
          )}
        </ul>
      </Text>
      <Text>
        <Text as="span" fontWeight="semibold">
          Positive impacts:
        </Text>
        <ul style={{ marginTop: 4 }}>
          {positiveExplanation ? (
            <>
              <li>{positiveExplanation}</li>
              {positiveExample && <li>Simplified example: {formatImpactCategoryExample(positiveExample)}</li>}
            </>
          ) : (
            <li>No positive impacts are considered for this impact category.</li>
          )}
        </ul>
      </Text>
    </Box>
  );
};

function formatImpactCategoryExample(text: string) {
  return text.toLowerCase().replace('example:', '');
}
